import { Link } from "react-router-dom";
import { useState, useEffect, useMemo, useRef } from "react"
import { useLocation } from 'react-router-dom';
import LogOut from "../logOut/logOut";
import Settings from "./settings";
import ContactUs from "./contactUs";
import { updateMobileNumber, updateOtp, userProfileUrl } from "../sharedApi/common";
import PrivacyAndPolicy from "./privacy_Policy";
import $ from 'jquery';
import 'bootstrap';
import 'bootstrap-datepicker';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { myImageUrl } from "../sharedApi/common";
import { Modal } from "react-bootstrap";
import MyAddresses from "./myAddresses";
import { BiChevronRight } from "react-icons/bi";
import TermsAndCondtions from "./terms_condtions";
import { getToken } from "../sharedApi/customeAxios";
import { decrypteData } from "../sharedApi/customeAxios";
import { useSelector } from "react-redux"
import { Helmet, HelmetProvider } from 'react-helmet-async';
import LogoutTimer from "../logOut/logOutTimer";

const selectData = state => state.data;

const MyProfileSettings = (props) => {

  const data = useSelector(selectData)

  // useEffect(() => {
  //   console.log(data.data)
  // }, []);


  const location = useLocation();
  const navigate = useNavigate();

  const startDateRef = useRef(null);
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [dob, setDob] = useState('')
  const [gender, setGender] = useState('')
  const [phone, setPhone] = useState('')
  const [phn, setPhn] = useState('')
  const [email, setEmail] = useState('')
  const [allergis, setAllergies] = useState('')
  const [loading, setLoading] = useState(false)
  const [messageError, setMessageError] = useState('')
  const [phoneMessageError, setPhoneMessageError] = useState('')
  const [phnMessageError, setPhnMessgaeError] = useState('')
  const [firstNameColor, setFirstNameColor] = useState('lightgrey')
  const [lastNameColor, setLastNameColor] = useState('lightgrey')
  const [dobColor, setDobColor] = useState('lightgrey')
  const [genderColor, setGenderColor] = useState('lightgrey')
  const [phoneColor, setPhoneColor] = useState('lightgrey')
  const [phnColor, setPhnColor] = useState('lightgrey')
  const [emailColor, setEmailColor] = useState('lightgrey')
  const [allergisColor, setAllergiesColor] = useState('lightgrey')
  const [image, setImage] = useState('');
  const [profileImage, setProfileImage] = useState('')
  const [firstNumber, setFirstNumber] = useState('')
  const [secondNumber, setSecondNumber] = useState('')
  const [thirdNumber, setThirdNumber] = useState('')
  const [fourthNumber, setFourthNumber] = useState('')
  const [fifthNumber, setfifthNumber] = useState('')
  const [sixthNumber, setSixthNumber] = useState('')
  const [dateOfBirth, setDateOfBirth] = useState('')
  const [changePhoneNumberColor, setChangePhoneNumberColor] = useState('lightgrey')

  const getProfileFromStorage = () => decrypteData();

  const [profile, setProfile] = useState(() => getProfileFromStorage());
  const [EmailMessage, setEmailMessage] = useState('')

  const token = getToken();

  useMemo(() => {
    const myProfile = getProfileFromStorage();
    if (myProfile) {
      setProfile(myProfile);
      setFirstName(myProfile.first_name)
      setLastName(myProfile.last_name)
      // setDob(myProfile.date_of_birth)
      const date = new Date(myProfile.date_of_birth);
      const options = { year: 'numeric', month: 'short', day: 'numeric' };
      const formattedDate = date.toLocaleDateString('en-US', options);
      setDob(formattedDate)
      setDateOfBirth(myProfile.date_of_birth)
      // console.log(formattedDate);

      setGender(myProfile.sex)
      setPhone(myProfile.phone_number)
      setEmail(myProfile.email)
      setPhn(myProfile.phn)
      setAllergies(myProfile.allergy)
    }
  }, [location,]);

  useEffect(() => {
    if (!profile) {
      setProfile(getProfileFromStorage());
    }
  }, [profile]);

  // useEffect(() => {
  //   $(startDateRef.current).datepicker({
  //     format: 'yyyy-mm-dd',
  //     endDate: new Date()
  //   }).on('changeDate', function (e) {
  //     setDob(e.target.value);
  //     setDobColor('lightgrey')
  //   });
  // }, []);

  useEffect(() => {
    $(startDateRef.current).datepicker({
      format: 'yyyy-mm-dd',
      endDate: new Date()
    }).on('changeDate', function (e) {
      const date = new Date(e.target.value);
      const options = { month: 'short', day: 'numeric', year: 'numeric' };
      const formattedDate = date.toLocaleDateString('en-US', options);
      setDob(formattedDate);
      setDateOfBirth(e.target.value)
      setDobColor('lightgrey')
    });
  }, []);

  const submitUserProfile = async () => {
    setLoading(true)
    setMessageError('')
    setEmailMessage('')
    const rawResponse = await fetch(userProfileUrl,
      {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + token,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 'first_name': firstName, 'last_name': lastName, 'date_of_birth': dateOfBirth, 'sex': gender, 'phn': phn, 'phone_number': phone, 'allergy': allergis, 'email': email })
      })
    const result = await rawResponse.json();
    // console.log(result.data.email)
    if (result.success == true) {
      setLoading(false)
      navigate('/dashboard')
    }
    else if (result.data.email.includes('The email has already been taken.')) {
      setEmailColor('#FF4200')
      setEmailMessage('The email has already been taken.')
    }
    else {
      setMessageError('Something Went Wrong Try Again !!')
      setLoading(false)
    }
    return result;
  }

  const SubmitData = (e) => {
    e.preventDefault();
    if (!firstName) {
      setFirstNameColor('#FF4200')
    } else if (!lastName) {
      setLastNameColor('#FF4200')
    } else if (!dob) {
      setDobColor('#FF4200')
    } else if (!gender) {
      setGenderColor('#FF4200')
    } else if (!phone) {
      setPhoneColor('#FF4200')
    } else if (phone.length < 10 || phone.length > 10) {
      setPhoneMessageError('Enter 10 digit Number')
      setPhoneColor('#FF4200')
    } else if (!email) {
      setEmailColor('#FF4200')
    } else if (!phn) {
      setPhnColor('#FF4200')
    } else if (phn.length < 10 || phn.length > 10) {
      setPhnMessgaeError('Enter 10 digit Number')
      setPhnColor('#FF4200')
    }
    else {
      submitImage();
      submitUserProfile();
    }
  }

  /*----------------------------Profile Image ----------------------------------*/
  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const uploadImage = async (e) => {
    const file = e.target.files[0];
    const base64 = await convertBase64(file);
    setImage(base64)
    setProfileImage(base64.replace(/^data:image\/[a-z]+;base64,/, ""));
  };

  const submitImage = () => {
    const token = JSON.parse(localStorage.getItem('Token_access'))
    if (profileImage) {
      const formdata = new FormData();
      formdata.append('profile_image', profileImage.replace(/^data:image\/[a-z]+;base64,/, ""))
      axios.post(myImageUrl, formdata, {
        headers: {
          'Authorization': 'Bearer ' + token,
          'Accept': 'application/json',
          'Content-Type': 'multipart/form-data'
        }
      }).then((response) => {
        //  console.log(response.data) 
        return response
      });
    }
  }


  //----------------------------------------------Update Phone Number-------------------------------------------

  const [newPhoneNumber, setNewPhoneNumber] = useState('')
  const [mobileMessageError, setMobileMessageError] = useState('')
  const [showOTPModal, setShowOTPModal] = useState(false);

  const updateNumber = async () => {
    setMobileMessageError('')
    const token = JSON.parse(localStorage.getItem('Token_access'))
    const rawResponse = await fetch(updateMobileNumber, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({
        'phone_number': newPhoneNumber,
      })
    });
    const response = await rawResponse.json();
    // console.log(response.data)
    if (response.data.status == 1) {
      setMobileMessageError('Otp has been send on this number')
      setShowOTPModal(true);
    } else {
      setMobileMessageError('Phone Number Already In Use')
      setChangePhoneNumberColor('#FF4200')
    }
  }

  const updatePhoneNumber = () => {
    if (newPhoneNumber.length < 10 || newPhoneNumber.length > 10) {
      setMobileMessageError('Please Enter 10 Digits Mobile Number')
      setChangePhoneNumberColor('#FF4200')
    } else {
      setOtpMessgaeError('')
      updateNumber();
      setFirstNumber('')
      setSecondNumber('')
      setThirdNumber('')
      setFourthNumber('')
      setfifthNumber('')
      setSixthNumber('')
    }
  }

  function handleKeyPress(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      updatePhoneNumber()
    }
  }

  const [otpMessgaeError, setOtpMessgaeError] = useState('')
  const [otpLoading, setOtpLoading] = useState(false)

  const loginNumber = async () => {
    const token = JSON.parse(localStorage.getItem('Token_access'))
    setOtpLoading(true)
    setOtpMessgaeError('')
    const rawResponse = await fetch(updateOtp, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({ 'phone_number': newPhoneNumber, 'otp': `${firstNumber}${secondNumber}${thirdNumber}${fourthNumber}${fifthNumber}${sixthNumber}` })
    });
    const content = await rawResponse.json();
    // console.log(content.success)
    if (content.success == false) {
      setOtpMessgaeError('Please enter a valid code')
      setOtpLoading(false)
    } else {
      setShowOTPModal(false)
      setOtpLoading(false)
      setMobileMessageError('')
      setInterval(() => {
        navigate('/dashboard')
      }, 2000);
    }
  }

  const submitOtp = () => {
    if (!firstNumber || !secondNumber || !thirdNumber || !fourthNumber || !fifthNumber || !sixthNumber)
      setOtpMessgaeError('Please enter 6 Digit code Number')
    else {
      loginNumber();
    }
  }

  const firstInputRef = useRef(null);
  const secondInputRef = useRef(null);
  const thirdInputRef = useRef(null);
  const fourthInputRef = useRef(null);
  const fifthInputRef = useRef(null);
  const sixthInputRef = useRef(null);

  function handleKeyUp(event, inputRef) {
    const maxLength = inputRef.current.maxLength;
    const currentLength = inputRef.current.value.length;
    if (currentLength === maxLength) {
      inputRef.current.blur();
      const nextInputRef = getNextInputRef(inputRef);
      if (nextInputRef) {
        nextInputRef.current.focus();
      }
    }
  }

  function getNextInputRef(inputRef) {
    switch (inputRef) {
      case firstInputRef:
        return secondInputRef;
      case secondInputRef:
        return thirdInputRef;
      case thirdInputRef:
        return fourthInputRef;
      case fourthInputRef:
        return fifthInputRef;
      case fifthInputRef:
        return sixthInputRef;
      default:
        return null;
    }
  }

  const [activeTab, setActiveTab] = useState(parseInt(localStorage.getItem("activeTab")) || 0);

  useEffect(() => {
    localStorage.setItem("activeTab", activeTab);
  }, [activeTab]);

  const handleTabChange = (index) => {
    setActiveTab(index);
  };


  const handleEmailChange = (e) => {
    const enteredEmail = e.target.value;
    setEmail(enteredEmail);
    setEmailColor('lightgrey');
  }

  return (<>

    <HelmetProvider>
      <Helmet>
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>
    </HelmetProvider>
    <LogoutTimer onLogout={props.logOut} />        


    <section className="dark-back">
      <div className="profile-2-col wx_myProfileSpc">
        <div className="container justify-content-center align-items-center wx_myprofileTextLeftBg">
          <div className="row">
            <div className="col-md-12 col-lg-4 wx_myprofileBgMain">
              <div className="card-logo-col wx_myprofileBg">
                <Link to='/dashboard'>
                  <img src="./images/logo.svg" />
                </Link>

                <div className="user-dropdown-group">
                  <div className="user-dropdown-toggle d-flex align-items-center">
                    <img src={profile?.profile_image} />
                    <div className="media-body ms-3 me-auto">
                      <h5 className="mt-0">{props.day}</h5>
                      <h4> {profile?.full_name} </h4>
                    </div>

                    <div className="wx_ShowHideTab">
                      <button className="accordion-button collapsed m-0" type="button">
                        <img src="./images/myprofile/settingic.svg" alt="" />
                      </button>
                    </div>

                  </div>
                </div>

                <div className="wx_BackToHome">
                  <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.9375 20.3125H7.4375V12.4375H14.5625V20.3125H19.0625V8.21875L11 2.1875L2.9375 8.21875V20.3125ZM2.9375 22.4375C2.35417 22.4375 1.85417 22.2292 1.4375 21.8125C1.02083 21.3958 0.8125 20.8958 0.8125 20.3125V8.21875C0.8125 7.88542 0.885417 7.56771 1.03125 7.26563C1.17708 6.96354 1.38542 6.70833 1.65625 6.5L9.71875 0.46875C9.90625 0.322917 10.1094 0.213542 10.3281 0.140625C10.5469 0.0677085 10.7708 0.03125 11 0.03125C11.2292 0.03125 11.4531 0.0677085 11.6719 0.140625C11.8906 0.213542 12.0937 0.322917 12.2812 0.46875L20.3438 6.5C20.6146 6.70833 20.8229 6.96354 20.9688 7.26563C21.1146 7.56771 21.1875 7.88542 21.1875 8.21875V20.3125C21.1875 20.8958 20.9792 21.3958 20.5625 21.8125C20.1458 22.2292 19.6458 22.4375 19.0625 22.4375H12.5312V14.4688H9.46875V22.4375H2.9375Z" fill="white" />
                  </svg>
                  <Link to='/dashboard' className="mb-0">DashBoard</Link>
                </div>

                <div className="d-flex align-items-start wx_myprofileTextLeft">
                  <div className="nav flex-column nav-pills me-3" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                    {/* <button className="nav-link active me-auto"  id="myprofile" data-bs-toggle="pill" data-bs-target="#myprofile-tab" type="button" role="tab" aria-controls="v-myprofile-tab" aria-selected="true"> */}
                    <button className={`nav-link ${activeTab === 0 ? "active" : ""}`} onClick={() => handleTabChange(0)}>

                      <svg className="me-2" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.50182 8.4042C7.39974 8.4042 6.5013 8.0568 5.80651 7.36201C5.11172 6.66722 4.76432 5.76878 4.76432 4.6667C4.76432 3.56462 5.11172 2.66618 5.80651 1.97139C6.5013 1.2766 7.39974 0.929199 8.50182 0.929199C9.60391 0.929199 10.5023 1.2766 11.1971 1.97139C11.8919 2.66618 12.2393 3.56462 12.2393 4.6667C12.2393 5.76878 11.8919 6.66722 11.1971 7.36201C10.5023 8.0568 9.60391 8.4042 8.50182 8.4042ZM14.6831 16.3823H2.32057C1.87335 16.3823 1.49002 16.2226 1.17057 15.9032C0.851128 15.5837 0.691406 15.2004 0.691406 14.7532V13.9865C0.691406 13.3476 0.851128 12.8006 1.17057 12.3453C1.49002 11.8901 1.89731 11.5427 2.39245 11.3032C3.47856 10.824 4.51675 10.4646 5.50703 10.225C6.49731 9.98545 7.49557 9.86566 8.50182 9.86566C9.50807 9.86566 10.5023 9.98944 11.4846 10.237C12.4669 10.4846 13.5011 10.8479 14.5872 11.3271C15.0984 11.5507 15.5136 11.8901 15.8331 12.3453C16.1525 12.8006 16.3122 13.3476 16.3122 13.9865V14.7532C16.3122 15.2004 16.1525 15.5837 15.8331 15.9032C15.5136 16.2226 15.1303 16.3823 14.6831 16.3823ZM2.32057 14.7532H14.6831V14.0104C14.6831 13.7549 14.6072 13.5113 14.4555 13.2797C14.3037 13.0481 14.1161 12.8764 13.8924 12.7646C12.8862 12.2854 11.9638 11.954 11.1253 11.7703C10.2867 11.5867 9.41224 11.4948 8.50182 11.4948C7.59141 11.4948 6.70894 11.5867 5.85443 11.7703C4.99991 11.954 4.07752 12.2854 3.08724 12.7646C2.86363 12.8764 2.67995 13.0481 2.5362 13.2797C2.39245 13.5113 2.32057 13.7549 2.32057 14.0104V14.7532ZM8.50182 6.77503C9.10877 6.77503 9.61189 6.57538 10.0112 6.17607C10.4105 5.77677 10.6102 5.27364 10.6102 4.6667C10.6102 4.05975 10.4105 3.55663 10.0112 3.15732C9.61189 2.75802 9.10877 2.55837 8.50182 2.55837C7.89488 2.55837 7.39175 2.75802 6.99245 3.15732C6.59314 3.55663 6.39349 4.05975 6.39349 4.6667C6.39349 5.27364 6.59314 5.77677 6.99245 6.17607C7.39175 6.57538 7.89488 6.77503 8.50182 6.77503Z" fill="#111111" />
                      </svg>
                      My Profile
                      <i className="fa-solid fa-angle-right ms-3"><BiChevronRight style={{ backgroundColor: 'white' }} /></i>
                    </button>

                    {/* <button className="nav-link me-auto" id="myaddress" data-bs-toggle="pill" data-bs-target="#myaddress-tab" type="button" role="tab" aria-controls="v-myaddress-tab" aria-selected="false"> */}
                    <button className={`nav-link ${activeTab === 1 ? "active" : ""}`} onClick={() => handleTabChange(1)}>
                      <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_232_2-385409)">
                          <path d="M8.4987 10.2603C8.96189 10.2603 9.35721 10.0965 9.68464 9.76911C10.0121 9.44168 10.1758 9.04636 10.1758 8.58317C10.1758 8.11998 10.0121 7.72466 9.68464 7.39723C9.35721 7.0698 8.96189 6.90609 8.4987 6.90609C8.0355 6.90609 7.64019 7.0698 7.31276 7.39723C6.98533 7.72466 6.82161 8.11998 6.82161 8.58317C6.82161 9.04636 6.98533 9.44168 7.31276 9.76911C7.64019 10.0965 8.0355 10.2603 8.4987 10.2603ZM8.4987 18.1905C10.623 16.2578 12.1923 14.5049 13.2065 12.9316C14.2207 11.3583 14.7279 9.97275 14.7279 8.77484C14.7279 6.89011 14.1249 5.3488 12.919 4.15088C11.7131 2.95296 10.2397 2.354 8.4987 2.354C6.75773 2.354 5.28429 2.95296 4.07839 4.15088C2.87248 5.3488 2.26953 6.89011 2.26953 8.77484C2.26953 9.97275 2.78863 11.3583 3.82682 12.9316C4.86502 14.5049 6.42231 16.2578 8.4987 18.1905ZM8.52266 19.7957C8.41085 19.7957 8.30703 19.7797 8.2112 19.7478C8.11536 19.7158 8.02752 19.6679 7.94766 19.604C5.5678 17.5116 3.78689 15.571 2.60495 13.7821C1.423 11.9932 0.832031 10.3241 0.832031 8.77484C0.832031 6.379 1.60269 4.47032 3.14401 3.0488C4.68533 1.62727 6.47023 0.916504 8.4987 0.916504C10.5272 0.916504 12.3121 1.62727 13.8534 3.0488C15.3947 4.47032 16.1654 6.379 16.1654 8.77484C16.1654 10.3241 15.5744 11.9932 14.3924 13.7821C13.2105 15.571 11.4296 17.5116 9.04974 19.604C8.96988 19.6679 8.88602 19.7158 8.79818 19.7478C8.71033 19.7797 8.61849 19.7957 8.52266 19.7957Z" fill="#111111" />
                        </g>
                        <defs>
                          <clipPath id="clip0_232_2-385409">
                            <rect width="17" height="20" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>&nbsp;
                      My Addresses <i className=" fa-angle-right"><BiChevronRight style={{ backgroundColor: 'white' }} /></i></button>

                    {/* <button className="nav-link me-auto" id="settings" data-bs-toggle="pill" data-bs-target="#settings-tab" type="button" role="tab" aria-controls="v-settings-tab" aria-selected="false">
                      <svg className="me-2" width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.1053 20.2271H8.89488C8.68724 20.2271 8.50356 20.1632 8.34383 20.0354C8.18411 19.9077 8.08828 19.74 8.05633 19.5323L7.673 17.1604C7.40147 17.0646 7.10599 16.9249 6.78654 16.7412C6.4671 16.5575 6.18759 16.3698 5.948 16.1782L3.76779 17.1844C3.57613 17.2802 3.37647 17.2962 3.16884 17.2323C2.9612 17.1684 2.80946 17.0407 2.71363 16.849L1.08446 13.95C0.972655 13.7743 0.944704 13.5867 1.00061 13.387C1.05651 13.1874 1.16432 13.0236 1.32404 12.8959L3.3605 11.4104C3.32856 11.2827 3.30859 11.1309 3.30061 10.9552C3.29262 10.7795 3.28863 10.6278 3.28863 10.5C3.28863 10.3723 3.29262 10.2205 3.30061 10.0448C3.30859 9.86913 3.32856 9.71739 3.3605 9.58961L1.32404 8.1042C1.16432 7.97642 1.05651 7.81271 1.00061 7.61305C0.944704 7.4134 0.972655 7.22573 1.08446 7.05003L2.71363 4.15107C2.82543 3.95941 2.98116 3.83163 3.18082 3.76774C3.38047 3.70385 3.57613 3.71982 3.76779 3.81566L5.97196 4.82191C6.19557 4.63024 6.4671 4.44656 6.78654 4.27087C7.10599 4.09517 7.40147 3.95941 7.673 3.86357L8.05633 1.44378C8.08828 1.25212 8.18411 1.09239 8.34383 0.964616C8.50356 0.836838 8.68724 0.772949 8.89488 0.772949H12.1053C12.3129 0.772949 12.4966 0.836838 12.6563 0.964616C12.8161 1.09239 12.9119 1.25212 12.9438 1.44378L13.3272 3.83962C13.5987 3.95142 13.8982 4.09118 14.2256 4.25889C14.553 4.42659 14.8286 4.61427 15.0522 4.82191L17.2324 3.81566C17.424 3.71982 17.6237 3.70385 17.8313 3.76774C18.039 3.83163 18.1907 3.95941 18.2865 4.15107L19.9157 7.02607C20.0275 7.20177 20.0595 7.39344 20.0115 7.60107C19.9636 7.80871 19.8518 7.97642 19.6761 8.1042L17.6397 9.5417C17.6716 9.68545 17.6916 9.84517 17.6996 10.0209C17.7076 10.1966 17.7115 10.3563 17.7115 10.5C17.7115 10.6438 17.7076 10.7995 17.6996 10.9672C17.6916 11.1349 17.6716 11.2907 17.6397 11.4344L19.6761 12.8959C19.8358 13.0236 19.9437 13.1874 19.9996 13.387C20.0555 13.5867 20.0275 13.7743 19.9157 13.95L18.2865 16.849C18.1747 17.0407 18.019 17.1684 17.8194 17.2323C17.6197 17.2962 17.424 17.2802 17.2324 17.1844L15.0282 16.1782C14.8046 16.3698 14.5371 16.5615 14.2256 16.7532C13.9141 16.9448 13.6147 17.0806 13.3272 17.1604L12.9438 19.5323C12.9119 19.74 12.8161 19.9077 12.6563 20.0354C12.4966 20.1632 12.3129 20.2271 12.1053 20.2271ZM10.5001 13.6146C11.3626 13.6146 12.0973 13.3111 12.7043 12.7042C13.3112 12.0973 13.6147 11.3625 13.6147 10.5C13.6147 9.63753 13.3112 8.90281 12.7043 8.29587C12.0973 7.68892 11.3626 7.38545 10.5001 7.38545C9.63758 7.38545 8.90286 7.68892 8.29592 8.29587C7.68897 8.90281 7.3855 9.63753 7.3855 10.5C7.3855 11.3625 7.68897 12.0973 8.29592 12.7042C8.90286 13.3111 9.63758 13.6146 10.5001 13.6146ZM10.5001 12.1771C10.0209 12.1771 9.62161 12.0134 9.30217 11.686C8.98272 11.3585 8.823 10.9632 8.823 10.5C8.823 10.0368 8.98272 9.64152 9.30217 9.31409C9.62161 8.98666 10.0209 8.82295 10.5001 8.82295C10.9633 8.82295 11.3586 8.98666 11.686 9.31409C12.0135 9.64152 12.1772 10.0368 12.1772 10.5C12.1772 10.9632 12.0135 11.3585 11.686 11.686C11.3586 12.0134 10.9633 12.1771 10.5001 12.1771ZM9.49383 18.5979H11.5063L11.8418 15.9146C12.3688 15.7868 12.872 15.5872 13.3511 15.3157C13.8303 15.0441 14.2615 14.7087 14.6449 14.3094L17.1845 15.4115L18.0949 13.7584L15.8428 12.1292C15.9067 11.8577 15.9626 11.5861 16.0105 11.3146C16.0584 11.0431 16.0824 10.7716 16.0824 10.5C16.0824 10.2285 16.0624 9.95698 16.0225 9.68545C15.9825 9.41392 15.9227 9.14239 15.8428 8.87086L18.0949 7.2417L17.1845 5.58857L14.6449 6.69066C14.2775 6.25941 13.8582 5.90003 13.3871 5.61253C12.9159 5.32503 12.4008 5.14934 11.8418 5.08545L11.5063 2.40212H9.49383L9.15842 5.08545C8.61536 5.18128 8.10425 5.36896 7.62508 5.64847C7.14592 5.92798 6.71467 6.27538 6.33134 6.69066L3.81571 5.58857L2.90529 7.2417L5.13342 8.87086C5.06953 9.14239 5.01762 9.41392 4.97769 9.68545C4.93776 9.95698 4.91779 10.2285 4.91779 10.5C4.91779 10.7716 4.93776 11.0431 4.97769 11.3146C5.01762 11.5861 5.06953 11.8577 5.13342 12.1292L2.90529 13.7584L3.81571 15.4115L6.33134 14.3094C6.73064 14.7087 7.16988 15.0441 7.64904 15.3157C8.12821 15.5872 8.63134 15.7868 9.15842 15.9146L9.49383 18.5979Z" fill="#111111" />
                      </svg>
                      Settings <i className="fa-solid fa-angle-right"><BiChevronRight style={{ backgroundColor: 'white' }} /></i></button> */}

                    {/* <button className="nav-link me-auto" id="contactus" data-bs-toggle="pill" data-bs-target="#contactus-tab" type="button" role="tab" aria-controls="v-contactus-tab" aria-selected="false"> */}
                    <button className={`nav-link ${activeTab === 2 ? "active" : ""}`} onClick={() => handleTabChange(2)}>

                      <svg className="me-2" width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.3385 20.0832L10.099 17.4478H9.14062C6.8566 17.4478 4.90799 16.6412 3.29479 15.028C1.6816 13.4148 0.875 11.4662 0.875 9.18213C0.875 6.8981 1.68559 4.94949 3.30677 3.3363C4.92795 1.7231 6.88854 0.916504 9.18854 0.916504C10.3226 0.916504 11.3727 1.12015 12.3391 1.52744C13.3054 1.93473 14.1479 2.50574 14.8667 3.24046C15.5854 3.97518 16.1484 4.84168 16.5557 5.83994C16.963 6.8382 17.1667 7.92831 17.1667 9.11025C17.1667 11.2505 16.5637 13.3149 15.3578 15.3035C14.1519 17.292 12.4788 18.8853 10.3385 20.0832ZM9.18854 14.7405C9.4441 14.7405 9.65972 14.6526 9.83542 14.4769C10.0111 14.3012 10.099 14.0856 10.099 13.83C10.099 13.5745 10.0111 13.3589 9.83542 13.1832C9.65972 13.0075 9.4441 12.9196 9.18854 12.9196C8.93299 12.9196 8.71736 13.0075 8.54167 13.1832C8.36597 13.3589 8.27813 13.5745 8.27813 13.83C8.27813 14.0856 8.36597 14.3012 8.54167 14.4769C8.71736 14.6526 8.93299 14.7405 9.18854 14.7405ZM9.14062 11.4821C9.30035 11.4821 9.4401 11.4262 9.5599 11.3144C9.67969 11.2026 9.75556 11.0589 9.7875 10.8832C9.83542 10.6596 9.93524 10.4439 10.087 10.2363C10.2387 10.0287 10.4743 9.76511 10.7937 9.44567C11.225 9.01442 11.5285 8.61911 11.7042 8.25973C11.8799 7.90036 11.9677 7.51303 11.9677 7.09775C11.9677 6.379 11.7241 5.78803 11.237 5.32484C10.7498 4.86164 10.099 4.63005 9.28437 4.63005C8.72535 4.63005 8.21024 4.75383 7.73906 5.0014C7.26788 5.24897 6.88854 5.59636 6.60104 6.04359C6.50521 6.18734 6.48924 6.33508 6.55312 6.48682C6.61701 6.63855 6.73681 6.75435 6.9125 6.83421C7.04028 6.88213 7.17604 6.88213 7.31979 6.83421C7.46354 6.7863 7.58333 6.69845 7.67917 6.57067C7.85486 6.31511 8.07448 6.12744 8.33802 6.00765C8.60156 5.88786 8.89305 5.82796 9.2125 5.82796C9.69167 5.82796 10.067 5.94376 10.3385 6.17536C10.6101 6.40696 10.7458 6.71442 10.7458 7.09775C10.7458 7.40123 10.658 7.70869 10.4823 8.02015C10.3066 8.33161 9.99514 8.71893 9.54792 9.18213C9.2125 9.53352 8.97292 9.82501 8.82917 10.0566C8.68542 10.2882 8.59757 10.5637 8.56562 10.8832C8.54965 11.0429 8.59757 11.1826 8.70937 11.3024C8.82118 11.4222 8.96493 11.4821 9.14062 11.4821ZM11.5365 16.0103V17.4957C12.8462 16.3936 13.8724 15.0958 14.6151 13.6024C15.3578 12.109 15.7292 10.6116 15.7292 9.11025C15.7292 7.1297 15.1102 5.50852 13.8724 4.24671C12.6345 2.98491 11.0733 2.354 9.18854 2.354C7.27187 2.354 5.6467 3.02084 4.31302 4.35452C2.97934 5.68821 2.3125 7.29741 2.3125 9.18213C2.3125 11.0669 2.97934 12.6761 4.31302 14.0097C5.6467 15.3434 7.2559 16.0103 9.14062 16.0103H11.5365Z" fill="#111111" />
                      </svg>
                      Contact Us <i className="fa-solid fa-angle-right"><BiChevronRight style={{ backgroundColor: 'white' }} /></i></button>

                    <button className={`nav-link ${activeTab === 3 ? "active" : ""}`} onClick={() => handleTabChange(3)}>
                      <svg className="me-2" width="17" height="21" viewBox="0 0 17 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.51641 11.6263L5.6237 9.73356C5.47995 9.58981 5.30425 9.51794 5.09661 9.51794C4.88898 9.51794 4.71328 9.58981 4.56953 9.73356C4.42578 9.87731 4.35391 10.053 4.35391 10.2606C4.35391 10.4683 4.42578 10.644 4.56953 10.7877L6.94141 13.1596C7.08516 13.3034 7.25686 13.3752 7.45651 13.3752C7.65616 13.3752 7.82786 13.3034 7.97161 13.1596L12.4039 8.72731C12.5317 8.59953 12.5956 8.43183 12.5956 8.22419C12.5956 8.01655 12.5317 7.84884 12.4039 7.72106C12.2761 7.59328 12.1124 7.52939 11.9128 7.52939C11.7131 7.52939 11.5494 7.59328 11.4216 7.72106L7.51641 11.6263ZM8.4987 20.0117C8.43481 20.0117 8.37491 20.0077 8.31901 19.9997C8.26311 19.9917 8.2112 19.9797 8.16328 19.9638C6.023 19.3249 4.26606 18.0112 2.89245 16.0226C1.51884 14.0341 0.832031 11.8499 0.832031 9.47002V4.77419C0.832031 4.47071 0.919879 4.19519 1.09557 3.94762C1.27127 3.70005 1.49488 3.52037 1.76641 3.40856L7.99557 1.0846C8.17127 1.02071 8.33898 0.98877 8.4987 0.98877C8.65842 0.98877 8.82613 1.02071 9.00182 1.0846L15.231 3.40856C15.5025 3.52037 15.7261 3.70005 15.9018 3.94762C16.0775 4.19519 16.1654 4.47071 16.1654 4.77419V9.47002C16.1654 11.8499 15.4786 14.0341 14.1049 16.0226C12.7313 18.0112 10.9744 19.3249 8.83412 19.9638L8.4987 20.0117ZM8.4987 18.5742C10.3355 17.9672 11.8329 16.8212 12.9909 15.1362C14.1489 13.4511 14.7279 11.5624 14.7279 9.47002V4.77419L8.4987 2.42627L2.26953 4.77419V9.47002C2.26953 11.5624 2.84852 13.4511 4.00651 15.1362C5.1645 16.8212 6.66189 17.9672 8.4987 18.5742Z" fill="#111111" />
                      </svg>
                      Privacy & Policy <i className="fa-solid fa-angle-right"><BiChevronRight style={{ backgroundColor: 'white' }} /></i></button>

                    <button className={`nav-link ${activeTab === 4 ? "active" : ""}`} onClick={() => handleTabChange(4)}>
                      <svg className="me-2" width="17" height="21" viewBox="0 0 17 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.51641 11.6263L5.6237 9.73356C5.47995 9.58981 5.30425 9.51794 5.09661 9.51794C4.88898 9.51794 4.71328 9.58981 4.56953 9.73356C4.42578 9.87731 4.35391 10.053 4.35391 10.2606C4.35391 10.4683 4.42578 10.644 4.56953 10.7877L6.94141 13.1596C7.08516 13.3034 7.25686 13.3752 7.45651 13.3752C7.65616 13.3752 7.82786 13.3034 7.97161 13.1596L12.4039 8.72731C12.5317 8.59953 12.5956 8.43183 12.5956 8.22419C12.5956 8.01655 12.5317 7.84884 12.4039 7.72106C12.2761 7.59328 12.1124 7.52939 11.9128 7.52939C11.7131 7.52939 11.5494 7.59328 11.4216 7.72106L7.51641 11.6263ZM8.4987 20.0117C8.43481 20.0117 8.37491 20.0077 8.31901 19.9997C8.26311 19.9917 8.2112 19.9797 8.16328 19.9638C6.023 19.3249 4.26606 18.0112 2.89245 16.0226C1.51884 14.0341 0.832031 11.8499 0.832031 9.47002V4.77419C0.832031 4.47071 0.919879 4.19519 1.09557 3.94762C1.27127 3.70005 1.49488 3.52037 1.76641 3.40856L7.99557 1.0846C8.17127 1.02071 8.33898 0.98877 8.4987 0.98877C8.65842 0.98877 8.82613 1.02071 9.00182 1.0846L15.231 3.40856C15.5025 3.52037 15.7261 3.70005 15.9018 3.94762C16.0775 4.19519 16.1654 4.47071 16.1654 4.77419V9.47002C16.1654 11.8499 15.4786 14.0341 14.1049 16.0226C12.7313 18.0112 10.9744 19.3249 8.83412 19.9638L8.4987 20.0117ZM8.4987 18.5742C10.3355 17.9672 11.8329 16.8212 12.9909 15.1362C14.1489 13.4511 14.7279 11.5624 14.7279 9.47002V4.77419L8.4987 2.42627L2.26953 4.77419V9.47002C2.26953 11.5624 2.84852 13.4511 4.00651 15.1362C5.1645 16.8212 6.66189 17.9672 8.4987 18.5742Z" fill="#111111" />
                      </svg>
                      Terms & Conditions <i className="fa-solid fa-angle-right"><BiChevronRight style={{ backgroundColor: 'white' }} /></i></button>
                  </div>
                </div>
              </div>


              <div className="wx_LogOutBg">
                <LogOut logOut={props.logOut} />
              </div>
            </div>

            <div className="col-md-12 col-lg-8">
              <div className="profile-right-col">
                <div className="tab-content">
                  {/* <!-- My Profile --> */}
                  <div className={`tab-pane ${activeTab === 0 ? "active" : ""}`}>
                    <h2> My Profile </h2>
                    <div className="card wx_myprofileTextRight">
                      <div className="card-body">
                        <form onSubmit={SubmitData}>

                          <div className="row">


                            {/* ---------------------------------------------------------------Profile Pic Section Start --------------------------------------------------------*/}

                            <div className="col-sm-12 col-md-6 col-lg-3">

                              <div className="wx_myProfileCard">
                                {image ? <img src={image} alt="Profile" /> : <img src={profile?.profile_image} />}
                              </div>

                              <div className="myprofile_upload">
                                <input type="file" id="myFile" name='file' onChange={(e) => uploadImage(e)} />
                                <button type="button" className="btn btn-primary">Upload Photo</button>
                              </div>

                            </div>

                            {/* ---------------------------------------------------------------------Start End-----------------------------------------------------------           */}

                            {/*--------------------------------------------------------Provide Your Personal Details Section Start----------------------------------------------------------*/}

                            <div className="col-md-3">
                              <label htmlFor="formGroupExampleInput" className="form-label"></label>
                              <div className="form-floating mb-3">
                                <input type="text" onChange={(e) => { return setFirstName(e.target.value), setFirstNameColor('lightgrey') }} defaultValue={firstName} style={{ borderColor: firstNameColor }} className="form-control" id="formGroupExampleInput" placeholder="2658468972" />
                                <span className="form-icon"><img src="./images/myprofile/user.svg" alt="" /></span>
                                <label htmlFor="emailAddress">  first name </label>
                              </div>
                            </div>

                            <div className="col-md-3">
                              <label htmlFor="formGroupExampleInput" className="form-label"></label>
                              <div className="form-floating mb-3">
                                <input type="text" onChange={(e) => { return setLastName(e.target.value), setLastNameColor('lightgrey') }} defaultValue={lastName} style={{ borderColor: lastNameColor }} className="form-control" id="formGroupExampleInput" placeholder="2658468972" />
                                <span className="form-icon"><img src="./images/myprofile/user.svg" alt="" /></span>
                                <label htmlFor="emailAddress"> last name </label>
                              </div>
                            </div>

                            <div className="col-sm-12 col-md-6 col-lg-3">
                              <label htmlFor="formGroupExampleInput" className="form-label"></label>
                              <div className="input-group date" id="startDate">
                                <span className="input-group-addon input-group-text" ><img src="./images/myprofile/calendar.svg" alt="" /></span>
                                <input type="text" defaultValue={dob} className="form-control" style={{ borderColor: dobColor }} name="startDate" placeholder="yyyy-mm-dd" ref={startDateRef} />
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="checkbox-row mb-3 wx_selectGender">
                                <label htmlFor="emailAddress"> Select Your Gender </label>
                                <div className="checkbox-col">

                                  <div className="form-check">
                                    <input className="form-check-input" type="radio" name="gender" style={{ borderColor: genderColor }} defaultValue="male" checked={gender === 'male'} onChange={(e) => setGender(e.target.value)} id="flexRadioDefault1" />
                                    <label className="form-check-label" htmlFor="flexRadioDefault1">
                                      Male
                                    </label>
                                  </div>

                                  <div className="form-check">
                                    <input className="form-check-input" type="radio" name="gender" defaultValue="female" checked={gender === 'female'} onChange={(e) => setGender(e.target.value)} id="flexRadioDefault2" />
                                    <label className="form-check-label" htmlFor="flexRadioDefault2">
                                      Female
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="col-sm-12 col-md-6 col-lg-4">
                              <label htmlFor="formGroupExampleInput" className="form-label"></label>
                              <div className="form-floating mb-3">
                                <input type="text" onKeyDown={(e) => { if (!/^\d+$/.test(e.key) && (e.key !== "Backspace")) { e.preventDefault(); } }} onChange={(e) => { return setPhone(e.target.value), setPhoneColor('lightgrey'), setPhoneMessageError('') }} defaultValue={phone} style={{ borderColor: phoneColor }} className="form-control" id="formGroupExampleInput" disabled />
                                <span className="form-icon"> <img src="./images/myprofile/callic.svg" alt="" /> </span>
                                <label htmlFor="emailAddress"> Phone number </label>{phoneMessageError}
                              </div>
                            </div>

                            <div className="col-sm-12 col-md-6 col-lg-4">
                              <label htmlFor="formGroupExampleInput" className="form-label"></label>
                              <div className="form-floating mb-3">
                                <input type="email" onChange={handleEmailChange} value={email} style={{ borderColor: emailColor }} className="form-control" id="formGroupExampleInput" placeholder="georgebrown@xyz.com" />
                                <span className="form-icon"> <img src="./images/myprofile/emailic.svg" alt="" /> </span>
                                <label htmlFor="emailAddress"> Email address </label>{EmailMessage}
                              </div>
                            </div>

                          </div>

                          {/* -------------------------------------------------------------Section End----------------------------------------------------------------*/}

                          {/* -----------------------------------------------------Provide Your Medical Info Section Start----------------------------------------------------------------*/}
                          <hr />
                          <h4>Medical info</h4>

                          <div className="row">
                            <div className="col-md-6">
                              <label htmlFor="formGroupExampleInput" className="form-label"></label>
                              <div className="form-floating mb-3">
                                <input type="text" onKeyDown={(e) => { if (!/^\d+$/.test(e.key) && (e.key !== "Backspace") && e.keyCode !== 9) { e.preventDefault(); } }} onChange={(e) => { return setPhn(e.target.value.replace(/\D/g, '').slice(0, 10)), setPhnColor('lightgrey'), setPhnMessgaeError('') }} value={phn} style={{ borderColor: phnColor }} className="form-control" id="formGroupExampleInput" placeholder="2658468972" />
                                {/* <input type="text"
                                  onKeyDown={(e) => {
                                    if (!/^\d+$/.test(e.key) && (e.key !== "Backspace") && e.keyCode !== 9) {
                                      e.preventDefault();
                                    }
                                  }}
                                  onChange={(e) => {
                                    return setPhn(e.target.value.replace(/\D/g, '').slice(0, 10)), setPhnColor('lightgrey'), setPhnMessgaeError('')
                                  }}
                                  value={phn}
                                  style={{ borderColor: phnColor }}
                                  className="form-control"
                                  id="formGroupExampleInput"
                                  placeholder="2658468972"
                                /> */}

                                <span className="form-icon"><img src="./images/myprofile/phnic.svg" alt="" /></span>
                                <label htmlFor="emailAddress"> PHN number </label>{phnMessageError}
                              </div>
                            </div>

                            <div className="col-md-6">
                              <label htmlFor="formGroupExampleInput" className="form-label"></label>
                              <div className="form-floating mb-3">
                                <input type="text" onChange={(e) => { return setAllergies(e.target.value), setAllergiesColor('lightgrey') }} defaultValue={allergis} style={{ borderColor: allergisColor }} className="form-control" id="formGroupExampleInput" placeholder="Nasal Allergies (Rhinitis)" />
                                <span className="form-icon"><img src="./images/myprofile/allergiesic.svg" alt="" /></span>
                                <label htmlFor="emailAddress"> Allergies </label>
                              </div>
                            </div>
                          </div>

                          {/* ----------------------------------------------------- Section End----------------------------------------------------------------*/}

                          <hr />
                          {/* ------------------------------------------------Change Mobile Number Section Start ---------------------------------------------------------- */}

                          <h4 className="mb-4">Change Phone Number</h4>
                          <div className="row">
                            <div className="col-md-6">
                              {/* <label htmlFor="formGroupExampleInput" className="form-label">New enter phone number</label> */}
                              <div className="form-floating mb-3">
                                <input type="text" className="form-control" style={{ borderColor: changePhoneNumberColor }} onKeyDown={(e) => { if (!/^\d+$/.test(e.key) && (e.key !== "Backspace") && (e.key !== "Enter")) { e.preventDefault(); } }} value={newPhoneNumber} name="phone_number" onChange={(e) => { return setNewPhoneNumber(e.target.value.replace(/\D/g, '').slice(0, 10)), setChangePhoneNumberColor('lightgrey') }} id="formGroupExampleInput" placeholder="Sycamore Street" onKeyPress={handleKeyPress} />
                                <span className="form-icon"> <img src="./images/myprofile/callic.svg" alt="" /> </span>
                                <label htmlFor="emailAddress"> Enter new phone number </label>
                              </div>
                            </div>
                          </div>

                          <p className="change_mobileNo" style={{ color: '#FF4200' }}>{mobileMessageError}</p>
                          <div className="text-left mt-3">
                            <button onClick={updatePhoneNumber} className="btn btn-primary btn-lg submitButton sendOtp" type="button" >Send OTP</button>
                          </div>

                          {/* -----------------------------------------------------------Section End---------------------------------------------------------- */}

                          {/* -----------------------------------------------------------Submit Data Section Start---------------------------------------------------------- */}

                          <p style={{ textAlign: 'center', }}>{messageError}</p>
                          <div className="">
                            <button className="btn btn-primary btn-lg submitButton" id="submitButton" type="submit">
                              {loading ? 'Processing..' : 'Update Profile'}</button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>

                  {/* -----------------------------------------------------------Section End---------------------------------------------------------- */}

                  <div className={`tab-pane ${activeTab === 1 ? "active" : ""}`}>
                    <MyAddresses />
                  </div>

                  <div className={`tab-pane ${activeTab === 2 ? "active" : ""}`}>
                    <ContactUs />
                  </div>
                  <div className={`tab-pane ${activeTab === 3 ? "active" : ""}`}>
                    <PrivacyAndPolicy />
                  </div>

                  <div className={`tab-pane ${activeTab === 4 ? "active" : ""}`}>
                    <TermsAndCondtions />
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      {/* // <!-- ThankYou --> */}
      {/* // <!-- Modal --> */}

      <Modal show={showOTPModal} onHide={() => setShowOTPModal(false)} className="modal fade wx_OTPModal" centered >
        <div className="modal-header d-block text-center border-0">
          <h1 className="modal-title fs-5 m-0" id="exampleModalLabel">Verification Code</h1>
          <h6>*We have sent verification to Your Mobile Number</h6>
        </div>
        <div className="modal-body text-center">
          <p>{newPhoneNumber}</p>
          <div className="p-2 text-center">
            <div id="otp" className="inputs d-flex flex-row justify-content-center">

              <input className="m-2 text-center form-control" ref={firstInputRef}
                onKeyUp={(event) => handleKeyUp(event, firstInputRef)} value={firstNumber} onChange={(e) => setFirstNumber(e.target.value)} type="text" id="first" maxLength="1" />

              <input className="m-2 text-center form-control" ref={secondInputRef}
                onKeyUp={(event) => handleKeyUp(event, secondInputRef)} value={secondNumber} onChange={(e) => setSecondNumber(e.target.value)} type="text" id="second" maxLength="1" />

              <input className="m-2 text-center form-control" ref={thirdInputRef}
                onKeyUp={(event) => handleKeyUp(event, thirdInputRef)} value={thirdNumber} onChange={(e) => setThirdNumber(e.target.value)} type="text" id="third" maxLength="1" />

              <input className="m-2 text-center form-control" ref={fourthInputRef}
                onKeyUp={(event) => handleKeyUp(event, fourthInputRef)} value={fourthNumber} onChange={(e) => setFourthNumber(e.target.value)} type="text" id="fourth" maxLength="1" />

              <input className="m-2 text-center form-control" ref={fifthInputRef}
                onKeyUp={(event) => handleKeyUp(event, fifthInputRef)} value={fifthNumber} onChange={(e) => setfifthNumber(e.target.value)} type="text" id="fifth" maxLength="1" />

              <input className="m-2 text-center form-control" ref={sixthInputRef}
                onKeyUp={(event) => handleKeyUp(event, sixthInputRef)} value={sixthNumber} onChange={(e) => setSixthNumber(e.target.value)} type="text" id="sixth" maxLength="1" />
            </div>
          </div>
        </div>
        <p style={{ textAlign: 'center' }}>{otpMessgaeError}</p>
        <div className="modal-footer border-0">
          <button type="button" className="btn btn-secondary" onClick={() => setShowOTPModal(false)}>Cancel</button>
          <button type="button" className="btn btn-primary" onClick={submitOtp}>
            {otpLoading ? 'Processing...' : 'Submit'}
          </button>
        </div>
      </Modal>

    </section>
  </>)
}
export default MyProfileSettings;